export default __webpack_public_path__ + "static/media/bell2.6772bdaa.svg";